module.exports = __webpack_public_path__ + "img/me.me3b8260d.svg";